import React, { useState } from "react";
import './Pagination.css';
import { Globals } from "../../global/Globals";
 
 
const Pagination = ({ totalPages, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentIndex,setCurrentIndex] = useState(1);
  isNaN(totalPages) && (totalPages = 1);
  const handleIndexClick=(index)=>{
    if(currentPage>3 && currentIndex===1 && index===0){
      handleEllipsisClick("left");
      return;
    }
    if(index>totalPages || index<1){
      return;
    }
    setCurrentPage(index);
    setCurrentIndex(index);
    onPageChange(index,(page=1)=>{handleIndexClick(page);});
  }
 
  const handleEllipsisClick = (type) => {
    if (type === "left") {
      setCurrentPage((prev) => {
        return Math.max(1, prev - 3);
      });
    } else if (type === "right") {
    //  const nextPage = Math.min(totalPages, prev + 3);
    // console.log("currentpage", nextPage);
         setCurrentPage((prev) => Math.min(totalPages, prev + 3));
    }
  };
 
  const renderPages = () => {
    const pages = [];
    if (totalPages <= 5) {
      // Show all pages if <= 5
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Handle large page ranges
      if (currentPage < 3) {
        pages.push(1, 2, 3, "right");
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          "first",
          "left",
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          "left",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "right"
        );
      }
    }
    return pages;
  };
  let leftArrowActive= currentIndex!==1 &&((currentPage>3 && currentIndex===1) || currentIndex !== 1);;
  return (
    <div className="pagination">
      <div className={`arrow-btn ${currentIndex !== 1 && 'not-disabled'}`}
        disabled={currentIndex === 1}
        onClick={() => handleIndexClick(currentIndex - 1)}
      >
        <img className={`${leftArrowActive && 'not-disabled'}`} src={!leftArrowActive ? Globals.IMG.DESC_ARROW_DISABLED: Globals.IMG.DESC_ARROW} />
      </div>
 
      {renderPages().map((page, index) => {
        if (page === "left") {
          // return 0
        }else if (page === "first") {
          return (
            <>
            <div
              key={1}
              className={1 === currentIndex ? "active number-btn" : " number-btn"}
              onClick={() => handleIndexClick(1)}
            >
              {1}
            </div>
            <div className="number-btn" key={index} onClick={() => handleEllipsisClick("left")}>
              ...
            </div>
          </>
          );
        } else if (page === "right") {
          return (
            <>
            <div className="number-btn" key={index} onClick={() => handleEllipsisClick("right")}>
              ...
            </div>
            <div
              key={totalPages}
              className={totalPages === currentIndex ? "active number-btn" : " number-btn"}
              onClick={() => handleIndexClick(totalPages)}
            >
              {totalPages}
            </div>
          </>
          );
        } else {
          return (
            <div
              key={page}
              className={page === currentIndex ? "active number-btn" : " number-btn"}
              onClick={() => handleIndexClick(page)}
            >
              {page}
            </div>
          );
        }
      })}
 
      <div className={`arrow-btn ${currentIndex} ${totalPages}`}
        disabled={currentIndex === totalPages}
        onClick={() => {
          handleIndexClick(currentIndex + 1)
        }}
      >
         <img className={`${currentIndex != totalPages && 'not-disabled'}`} src={currentIndex === totalPages ? Globals.IMG.INC_ARROW_DISABLED : Globals.IMG.INC_ARROW} />
      </div>
    </div>
  );
};
 
export default Pagination;